import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CustomerTypeArrayModel,
  CustomerTypeModel,
} from "../../models/CustomerTypeModel";

const initialCustomerState: CustomerTypeArrayModel = {
  all_CustomerTypes: [],
  particular_CustomerType: {
    customerTypeId: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isCustomerTypesFetching: false,
};
const CustomerSlice = createSlice({
  name: "Customer",
  initialState: initialCustomerState,
  reducers: {
    setCustomerTypes(state, action: PayloadAction<CustomerTypeModel[]>) {
      state.all_CustomerTypes = action.payload;
    },
    setParticularCustomerType(state, action: PayloadAction<CustomerTypeModel>) {
      state.particular_CustomerType = action.payload;
    },
    setIsCustomerTypesFetching(state, action: PayloadAction<boolean>) {
      state.isCustomerTypesFetching = action.payload;
    },
  },
});
export default CustomerSlice;
